import { render, staticRenderFns } from "./DesenvolvimentoAplicativosNavegantes.vue?vue&type=template&id=4a119d75&scoped=true"
import script from "./DesenvolvimentoAplicativosNavegantes.vue?vue&type=script&lang=js"
export * from "./DesenvolvimentoAplicativosNavegantes.vue?vue&type=script&lang=js"
import style0 from "./DesenvolvimentoAplicativosNavegantes.vue?vue&type=style&index=0&id=4a119d75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a119d75",
  null
  
)

export default component.exports